
import { defineComponent, PropType } from 'vue';

import SwiperContestList from './SwiperContestList.vue';

import { NavBar } from '@/types';
import { useRouter } from 'vue-router';

import { ArrowRightOutlined } from '@ant-design/icons-vue';

export default defineComponent({
  name: 'SwiperActivitySlide',
  props: {
    data: {
      type: Object as PropType<NavBar>,
      required: true,
    },
  },
  components: {
    SwiperContestList,
    ArrowRightOutlined,
  },
  setup(props) {
    const router = useRouter();
    const current = props.data.contestSummaryList[0];
    const slideList = props.data.contestSummaryList.slice(1);

    const checkDetail = () => {
      router.push({
        name: 'ItemDetail',
        params: {
          id: current.contestId,
        },
      });
    };
    // activity/:type/:activityId?/:itemId?/:suffix(s/.+)?
    const checkMore = () => {
      router.push({
        name: 'ActivityDetail',
        params: {
          type: current.activityTypeCode,
        },
      });
    };

    return {
      current,
      slideList,
      checkMore,
      checkDetail,
    };
  },
});
